export const useDaysConsideredInMarketsApr = () => {
  return 7;
};
